export const ar = {
  breadcrumb: "الإعدادات",
  storeConnection: {
    metaTitle: "ربط المتجر - OrderHub",
    metaDescription: "اربط وأدر تكامل متجر Shopify الخاص بك.",
    title: "ربط المتجر",
    breadcrumb: "ربط المتجر",
    subtitleDisconnected: "اربط متجر Shopify لبدء مزامنة الطلبات والعملاء",
    subtitleConnected: "متجر Shopify الخاص بك متصل ومتزامن",
    actionsTitle: "إجراءات",
    actionsDescription: "إدارة اتصال متجرك",
    connectSuccessToast: "تم ربط المتجر بنجاح.",
    connectFailedToast: "لم يكتمل الربط. حاول مرة أخرى.",
    reconnectFailedToast: "فشل بدء إعادة الربط. حاول مرة أخرى.",
    resyncFailedToast: "فشل بدء إعادة المزامنة. حاول مرة أخرى.",
    errors: {
      storeAlreadyConnected:
        "هذا المتجر على Shopify مربوط بالفعل بمساحة عمل أخرى.",
    },
    connecting: {
      heading: "جارٍ الاتصال بمتجرك…",
      description: "ستتم إعادة توجيهك إلى Shopify للتصريح بالاتصال. يتم تحديث هذه الصفحة تلقائيًا عند الاكتمال.",
    },
    card: {
      enterDomainTitle: "أدخل نطاق متجرك",
      noStoreTitle: "لا يوجد متجر مربوط",
      enterDomainDescription: "سنقوم بإعادة توجيهك إلى Shopify للتصريح بالاتصال",
      noStoreDescription: "اربط متجر Shopify لفتح جميع الميزات",
      readyToConnect: "جاهز للاتصال",
      readyToConnectDescription: "اربط متجر Shopify بأمان عبر OAuth الرسمي",
    },
    badge: {
      connected: "متصل",
      disconnected: "غير متصل",
    },
    input: {
      domainAriaLabel: "نطاق متجر Shopify",
      domainPlaceholder: "your-store",
      domainError: "أدخل اسم متجر صالح (حروف وأرقام وواصلات)",
    },
    actions: {
      connectShopifyStore: "ربط متجر Shopify",
      connect: "ربط",
      connecting: "جارٍ الاتصال…",
      runResync: "إعادة المزامنة الآن",
      resyncStarting: "جارٍ البدء...",
      reconnectShopify: "إعادة ربط Shopify",
      reconnecting: "جارٍ إعادة الربط...",
      disconnectConfirm: "فصل هذا المتجر؟ ستتوقف مزامنة البيانات.",
      disconnectStore: "فصل المتجر",
    },
    disconnectDialog: {
      subscriptionActiveTitle: "اشتراكك لا يزال نشطًا",
      subscriptionActiveSubtitle: "فصل المتجر لن يلغي الفوترة",
      subscriptionActiveBody: "فصل هذا المتجر لن يلغي اشتراكك — ستستمر في تحصيل الرسوم عبر Shopify. لإيقاف الفوترة، ألغِ اشتراكك من صفحة الفوترة أولاً.",
      youWillKeepBeingBilled: "ستستمر في تحصيل الرسوم",
      billingContinues: "تستمر الفوترة عبر Shopify",
      dataSyncStops: "تتوقف مزامنة البيانات فورًا",
      reconnectAnytime: "أعد الربط في أي وقت للاستئناف",
      cancelSubscriptionFirst: "إلغاء الاشتراك أولاً",
      disconnectAnyway: "الفصل على أي حال",
      simpleTitle: "فصل المتجر؟",
      simpleSubtitle: "سيؤدي هذا إلى إيقاف مزامنة البيانات من متجرك",
      simpleBody: "ستتوقف مزامنة البيانات من هذا المتجر. يمكنك إعادة الربط في أي وقت للاستئناف.",
      disconnect: "فصل",
      confirm: "فصل",
      cancel: "إلغاء",
    },
    verifyEmailAlert: "تحقق من بريدك الإلكتروني لربط متجر Shopify.",
    details: {
      title: "تفاصيل المتجر",
      description: "معلومات متجر Shopify المتصل",
      storeNameLabel: "اسم المتجر",
      storeUrlLabel: "رابط المتجر",
      connectedOnLabel: "تاريخ الربط",
      connectedByLabel: "تم الربط بواسطة",
      apiVersionLabel: "إصدار API",
      lastSyncLabel: "آخر مزامنة",
    },
    scopes: {
      title: "نطاقات الوصول",
      description: "الأذونات الممنوحة من Shopify",
      countSuffix: "نطاقات",
    },
    webhook: {
      title: "حالة Webhook",
      description: "تسليم الأحداث الفوري من Shopify",
      inactiveFallback: "غير نشط",
      registeredPrefix: "مسجل ",
      notRegistered: "غير مسجل",
    },
    reconnectAlert: {
      title: "أعد ربط Shopify إذا قمت بتغيير أذونات المتجر أو واجهت مشاكل في الاتصال.",
      description: "سيؤدي هذا إلى تحديث التفويض والتحقق من النطاقات وإعادة تسجيل الـ webhooks.",
    },
  },
  triggerRules: {
    metaTitle: "قواعد التشغيل - OrderHub",
    metaDescription: "تكوين محفزات المتابعة التي تنشئ المهام لفريقك.",
    title: "قواعد التشغيل",
    breadcrumb: "قواعد التشغيل",
    subtitle: "تكوين محفزات المتابعة التي تنشئ المهام لفريقك",
    changesApplyAlert: "تنطبق تغييرات المحفزات على السجلات الجديدة والمعالجة حديثًا من الآن فصاعدًا.",
    historyLink: "السجل",
    verifyEmailAlert: "تحقق من بريدك الإلكتروني لإنشاء أو تعديل قواعد التشغيل.",
    card: {
      recentCreatedLabel: "أُنشئت مؤخرًا",
      lastSevenDays: "آخر 7 أيام",
      editDisabledTooltip: "تحقق من بريدك الإلكتروني لتعديل المحفزات",
    },
    conditions: {
      paymentMethodsLabel: "طرق الدفع",
      paymentMethodsDescription: "تفعيل فقط للطلبات التي تستخدم طرق الدفع هذه",
      paymentMethodsPlaceholder: "مثال: cod, card",
      minOrderValueLabel: "الحد الأدنى لقيمة الطلب",
      minOrderValueDescription: "تخطي الطلبات الأقل من هذه القيمة",
      includeTagsLabel: "تضمين الوسوم",
      includeTagsDescription: "يجب أن يحتوي الطلب على واحد على الأقل من هذه الوسوم",
      includeTagsPlaceholder: "مثال: wholesale",
      excludeTagsLabel: "استبعاد الوسوم",
      excludeTagsDescription: "تخطي الطلبات التي تحتوي على أي من هذه الوسوم",
      excludeTagsPlaceholder: "مثال: confirmed",
      orderSourceLabel: "مصدر الطلب",
      orderSourceDescription: "تصفية حسب القناة التي نشأ منها الطلب",
      orderSourcePlaceholder: "مثال: web, mobile",
      minDraftValueLabel: "الحد الأدنى لقيمة المسودة",
      minDraftValueDescription: "تخطي الطلبات المسودة الأقل من هذه القيمة",
      includeTagsDraftDescription: "يجب أن يحتوي الطلب المسود على واحد على الأقل من هذه الوسوم",
      excludeTagsDraftDescription: "تخطي الطلبات المسودة التي تحتوي على أي من هذه الوسوم",
      requirePhoneLabel: "يتطلب هاتفًا",
      requirePhoneDescription: "تضمين الطلبات المسودة التي تحتوي على رقم هاتف العميل فقط",
      minCheckoutValueLabel: "الحد الأدنى لقيمة السلة",
      minCheckoutValueDescription: "تخطي السلات المتروكة الأقل من هذه القيمة",
      checkoutStepReachedLabel: "خطوة الدفع المتحقق منها",
      checkoutStepReachedDescription: "تفعيل فقط للسلات التي وصلت إلى واحدة على الأقل من هذه الخطوات",
      checkoutStepReachedPlaceholder: "مثال: contact, shipping, payment",
      returningCustomerOnlyLabel: "العملاء العائدون فقط",
      returningCustomerOnlyDescription: "تفعيل فقط للعملاء الذين لديهم سجل طلبات سابق",
      customerEnteredPhoneLabel: "هاتف العميل المُدخل",
      customerEnteredPhoneDescription: "تفعيل فقط عندما يتم التقاط رقم هاتف أثناء الدفع",
      checkoutSourceLabel: "مصدر السلة",
      checkoutSourceDescription: "تصفية حسب القناة التي نشأ منها الدفع",
      checkoutSourcePlaceholder: "مثال: web, mobile",
      includeCustomerTagsLabel: "تضمين وسوم العميل",
      includeCustomerTagsDescription: "يجب أن يحتوي العميل على واحد على الأقل من هذه الوسوم",
      includeCustomerTagsPlaceholder: "مثال: vip",
      excludeCustomerTagsLabel: "استبعاد وسوم العميل",
      excludeCustomerTagsDescription: "تخطي السلات من العملاء الذين لديهم أي من هذه الوسوم",
      excludeCustomerTagsPlaceholder: "مثال: do-not-contact",
      minValueRangeError: "يجب أن تكون القيمة رقمًا منتهيًا بين {{min}} و {{max}}.",
    },
    dialog: {
      editTitlePrefix: "تعديل: ",
      loadingRule: "جارٍ تحميل القاعدة...",
      enabledDescription: "تفعيل هذا المحفز لبدء معالجة السجلات المطابقة",
      conditionsHeading: "قواعد التشغيل",
      assignmentHeading: "التعيين",
      priorityLabel: "الأولوية",
      assignToLabel: "التعيين إلى",
      selectTeamFirstHint: "اختر فريقًا أولاً",
      unassignedOption: "غير معيّن",
      syncToShopifyLabel: "مزامنة العلامة مع Shopify",
      syncTagPlaceholder: "مثال: cod-confirm",
      syncTagHelperText: "أضف الوسم التالي إلى طلب Shopify المطابق.",
      changesApplyNote: "تنطبق التغييرات على السجلات المطابقة الجديدة من الآن فصاعدًا.",
      updatedTriggerToast: "تم حفظ التغييرات",
    },
  },
  triggerRulesHistory: {
    title: "تاريخ تغيير قواعد التشغيل",
    activityLogBadge: "سجل المهمة",
    subtitle: "تتبع كل تغيير في قواعد الطلبات الخاصة بك",
    stats: {
      totalActivity: "إجمالي المهمة",
      lastUpdated: "آخر تحديث",
      activeRules: "القواعد النشطة",
      activeRulesSub: "من إجمالي {{total}}",
    },
    filterBy: "تصفية حسب",
    clearFilters: "مسح المرشحات",
    loadMore: "تحميل المزيد من المهمة",
  },
  usersTeams: {
    metaTitle: "المستخدمون والفرق - OrderHub",
    metaDescription: "إدارة المستخدمين وأدوارهم وتعيينات الفريق.",
    title: "المستخدمون والفرق",
    breadcrumb: "المستخدمون والفرق",
    subtitle: "إدارة المستخدمين وأدوارهم وتعيينات الفريق.",
    rolesHeading: "الأدوار والأذونات",
    roles: {
      repName: "مندوب",
      repDescription: "يمكنه إدارة الأصناف والعملاء المعينين.",
      managerName: "مدير",
      managerDescription: "يمكنه عرض نشاط الفريق والتقارير.",
      adminName: "مدير عام",
      adminDescription: "وصول كامل للإعدادات والمستخدمين والفرق وتكوين النظام.",
      noteLabel: "ملاحظة",
      noteText: "ينتمي كل مستخدم إلى فريق واحد فقط",
    },
    usersCountHeading: "المستخدمون ({{count}})",
    inviteUser: "دعوة مستخدم",
    inviteUserLockedTooltip: "قم بترقية خطتك لدعوة المستخدمين",
    noTeam: "لا يوجد فريق",
    table: {
      userHeader: "المستخدم",
      emailHeader: "البريد الإلكتروني",
      roleHeader: "الدور",
      teamHeader: "الفريق",
      statusHeader: "الحالة",
      actionsHeader: "إجراءات",
      editUserAriaLabel: "تعديل المستخدم",
      editUserTooltip: "تعديل المستخدم",
      removeUserAriaLabel: "إزالة المستخدم",
      removeUserTooltip: "إزالة المستخدم",
      cancelInvitationAriaLabel: "إلغاء الدعوة",
      cancelInvitationTooltip: "إلغاء الدعوة",
    },
    teamsHeading: "الفرق",
    addTeam: "إضافة فريق",
    memberCount: "{{count}} أعضاء",
    editTeamAriaLabel: "تعديل الفريق",
    growthPlanSuffix: " (Growth)",
    inviteDialog: {
      title: "دعوة مستخدم",
      sentToastTitle: "تم إرسال الدعوة",
      sentToastDescription: "تم إرسال بريد إلكتروني إلى {{email}}",
      failedToastTitle: "فشل إرسال الدعوة",
      inviteButton: "دعوة",
    },
    teamDialog: {
      editTitle: "تعديل الفريق",
      addTitle: "إضافة فريق",
      teamNameLabel: "اسم الفريق",
      updatedToastTitle: "تم تحديث الفريق",
      updatedToastDescription: "تم حفظ \"{{name}}\"",
      updateFailedToastTitle: "فشل تحديث الفريق",
      createdToastTitle: "تم إنشاء الفريق",
      createdToastDescription: "تمت إضافة \"{{name}}\"",
      createFailedToastTitle: "فشل إنشاء الفريق",
    },
    editUserDialog: {
      title: "تعديل المستخدم",
      updatedToastTitle: "تم تحديث المستخدم",
      updatedToastDescription: "تم تحديث إعدادات {{name}}",
      updateFailedToastTitle: "فشل تحديث المستخدم",
    },
    resendButton: {
      resentToastTitle: "تمت إعادة إرسال الدعوة",
      resentToastDescription: "تم إرسال بريد إلكتروني إلى {{email}}",
      failedToastTitle: "فشل إعادة إرسال الدعوة",
      ariaLabel: "إعادة إرسال الدعوة",
      tooltip: "إعادة إرسال الدعوة",
    },
    cancelDialog: {
      title: "إلغاء الدعوة",
      body: "سيؤدي هذا إلى إلغاء الدعوة المعلقة لـ {{email}}. لن يتمكنوا من الانضمام إلى مساحة العمل باستخدام هذه الدعوة بعد الآن.",
      keepInvitation: "الاحتفاظ بالدعوة",
      cancelledToastTitle: "تم إلغاء الدعوة",
      cancelledToastDescription: "لن يتمكن {{email}} من الانضمام بعد الآن",
      cancelFailedToastTitle: "فشل إلغاء الدعوة",
      cancelling: "جارٍ الإلغاء...",
      cancelInvitationButton: "إلغاء الدعوة",
    },
    delete: {
      successTitle: "تم حذف المستخدم",
      successDescription: "تمت إزالة {{name}} من مساحة العمل",
      title: "حذف المستخدم",
      subtitle: "يحذف هذا المستخدم نهائيًا ويحرّر بريده الإلكتروني لإعادة الدعوة.",
      whatHappensTitle: "ماذا سيحدث بعد ذلك",
      bulletSignin: "يتم تسجيل خروجهم فورًا وفقدان جميع صلاحيات الوصول.",
      bulletActivities: "تنتقل المهام المفتوحة والمؤجلة إلى الزميل المحدد.",
      bulletHistory: "يستمر سجل النشاط في عرض اسم {{name}} لمدة ~6 أشهر، ثم يظهر \"مستخدم سابق\".",
      bulletEmail: "يتم تحرير بريدهم الإلكتروني ويمكن دعوتهم مرة أخرى في أي وقت.",
      transferLabel: "نقل المهام النشطة إلى",
      change: "تغيير",
      searchPlaceholder: "ابحث عن المستخدمين...",
      noUsersFound: "لم يتم العثور على مستخدمين",
      confirmText: "أتفهم أنه لا يمكن التراجع عن هذا الإجراء وسيتم إزالة المستخدم نهائيًا من مساحة العمل.",
      deleting: "جارٍ الحذف...",
      confirmButton: "حذف المستخدم",
    },
  },
  syncHealth: {
    metaTitle: "حالة المزامنة - OrderHub",
    metaDescription: "الحالة الفورية لمزامنة البيانات والمهام في الخلفية.",
    title: "حالة المزامنة",
    breadcrumb: "حالة المزامنة",
    subtitle: "الحالة الفورية لمزامنة البيانات والمهام في الخلفية.",
    loadError: "فشل تحميل حالة المزامنة.",
    status: {
      healthy: "سليم",
      running: "قيد التشغيل",
      errored: "به أخطاء",
      unknown: "غير معروف",
    },
    connectionStatusLabel: "حالة الاتصال: ",
    connectionConnected: "متصل ويعمل",
    connectionNotConnected: "غير متصل",
    pendingUpdateAlert: {
      title: "تحديث معلق",
      description: "لم يتم تشغيل المزامنة بعد. هذا طبيعي لتثبيت جديد. ستظهر البيانات هنا بمجرد اكتمال المزامنة الأولى.",
    },
    pipeline: {
      unknownName: "غير معروف",
      lastSuccessfulPrefix: "آخر نجاح: ",
      orders: "الطلبات (Shopify → OrderHub)",
      draft_orders: "الطلبات المسودة (Shopify → OrderHub)",
      checkouts: "السلات (Shopify → OrderHub)",
      customers: "العملاء (Shopify → OrderHub)",
      reconciliation: "التسوية كل 30 دقيقة",
    },
    healthyAlert: {
      title: "جميع الأنظمة سليمة",
      description: "تتم مزامنة البيانات كما هو متوقع.",
    },
    runningAlert: {
      title: "المزامنة قيد التقدم",
      description: "خطوط المعالجة قيد التشغيل حاليًا. تحقق مرة أخرى قريبًا للحصول على الحالة المحدثة.",
    },
    erroredAlert: {
      title: "تم اكتشاف مشاكل في المزامنة",
      description: "بعض خطوط المعالجة لا تتم مزامنتها بشكل صحيح. تحقق من حالات خط المعالجة أعلاه للحصول على التفاصيل.",
    },
  },
} as const;
